import type { 
  GetDomainsManagementDnsHostingsData,
  GetDomainsManagementDnsHostingsResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getDNSHostingsApiModule(affiliatesApi: AxiosInstance) {
  return {
    /**
     * Get all available dns hostings
     *
     * @returns {Promise<Object>} api response
     */
    getDNSHostingProviders() {
      return affiliatesApi.get<GetDomainsManagementDnsHostingsResponse>('/domains-management/dns-hostings');
    },
  }
}
